export const SETTINGS_REQUEST = 'settingsRequest';
export const SETTINGS_FAILURE = 'settingsFailure';
export const SETTINGS_SUCCESS = 'settingsSuccess';
